import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { ENV } from '@app/env';
import { ICoupon } from 'models/coupon.model';
import * as firebase from 'firebase';

@Injectable()
export class CouponData {

  public clientId = ENV.client;

  constructor(
    private afDatabase: AngularFireDatabase,
  ) { }

  getCoupons(clientId: string): Observable<ICoupon[]> {
    return this.afDatabase.list<ICoupon>(`/Clients/${clientId}/Coupons`,
      ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  public getActiveCoupons(): Observable<ICoupon[]> {
    return this.afDatabase.list<ICoupon>(`/Clients/${this.clientId}/Coupons`,
      ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  public getCouponsById(clientId: string, couponId: string, userId: string) {
    return this.afDatabase.object<ICoupon>(`/Clients/${clientId}/UserCoupons/${userId}/${couponId}`)
      .valueChanges();
  }

  public getCouponReferredById(clientId: string, couponId: string) {
    return this.afDatabase.object<ICoupon>(`/Clients/${clientId}/Coupons/${couponId}`)
      .valueChanges();
  }

  getCouponsRef(clientId: string) {
    return this.afDatabase.object(`/Clients/${clientId}/Coupons`)
      .query.ref;
  }

  public getCouponByCodeRef(codeInput: string): Promise<any> {
    return this.afDatabase.object(`/Clients/${this.clientId}/Coupons`)
      .query
      .ref
      .orderByChild('code')
      .equalTo(codeInput)
      .once('value')
      .then(snap => snap.val());
  }

  public getCouponUserByCodeRef(code: string, userId: string): Promise<any> {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${userId}`)
      .query
      .ref
      .orderByChild('code')
      .equalTo(code)
      .limitToFirst(1)
      .once('value')
      .then(snap => snap.val());
  }

  public getCouponUserByIdRef(idCoupon: string, userId: string): Promise<any> {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${userId}/${idCoupon}`)
      .query
      .ref
      .once('value')
      .then(snap => snap.val());
  }

  public getCouponsUserRef(clientId: string, userId: string) {
    return this.afDatabase.object(`/Clients/${clientId}/UserCoupons/${userId}`)
      .query.ref;
  }

  getUsersCouponsRef(clientId: string) {
    return this.afDatabase.object<any>(`/Clients/${clientId}/UserCoupons`)
      .query.ref;
  }

  getUsersCoupons(clientId: string) {
    return this.afDatabase.object<any>(`/Clients/${clientId}/UserCoupons`).valueChanges();
  }

  getCuponsUser(userId: string): Observable<ICoupon[]> {
    return this.afDatabase.list<ICoupon>(`/Clients/${this.clientId}/UserCoupons/${userId}/`).valueChanges();
  }

  getUsersCouponsQuantity(clientId: string, userId: string) {
    return this.afDatabase.list<any>(`/Clients/${clientId}/UserCoupons/${userId}`).valueChanges();
  }

  getReferralCouponRef(clientId: string) {
    return this.afDatabase.object(`/Clients/${clientId}/Referred`)
      .query.ref;
  }

  addCoupon(userId: string, coupon: ICoupon) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${userId}/${coupon.id}`).set({
      ...coupon,
      created_at: firebase.database.ServerValue.TIMESTAMP
    });
  }

  addReferalCoupon(coupon: ICoupon) {
    const id = this.afDatabase.createPushId();
    return this.afDatabase.object(`/Clients/${this.clientId}/Coupons/${id}`).set({
      autogenerate: true,
      ...coupon,
      created_at: firebase.database.ServerValue.TIMESTAMP,
      id,
      privacy: 'referred',
      type_code: 'qr',
      state: true
    }).then(() => id);
  }

  addCouponFromReferred(receiverUserId: string, senderUserId: string, coupon: ICoupon) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${receiverUserId}/${coupon.id}`).set({
      ...coupon,
      created_at: firebase.database.ServerValue.TIMESTAMP,
      senderUserId: senderUserId
    })
  }

  setUserReceivedCoupon(iduser) {
    return this.afDatabase.object(`/Clients/${this.clientId}/Users/${iduser}/receiveCoupon`).set(true);
  }

  setUserReferred(iduser, referredId) {
    return this.afDatabase.object(`/Clients/${this.clientId}/Users/${iduser}/partnerId`).set(referredId);
  }

  unsetUserReferredn(iduser) {
    return this.afDatabase.object(`/Clients/${this.clientId}/Users/${iduser}/partnerId`).remove();
  }

  unSetUserReceivedCoupon(iduser) {
    return this.afDatabase.object(`/Clients/${this.clientId}/Users/${iduser}/receiveCoupon`).set(false);
  }

  reduceCouponQuantity(coupon: ICoupon) {
    return this.afDatabase.object(`/Clients/${this.clientId}/Coupons/${coupon.id}/quota`)
      .query.ref.transaction(val => {
        if (val) return val - 1;
        return val;
      });
  }

  addCouponQuantity(coupon) {
    return this.afDatabase.object(`/Clients/${this.clientId}/Coupons/${coupon.id}/quota`)
      .query.ref.transaction(val => {
        if (val || val === 0) return val + 1;
        return val;
      });
  }

  validateAddCuponRef(userId, couponId) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${userId}/${couponId}`).query.ref;
  }

  removeCoupon(userId, coupon) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${userId}/${coupon.id}`).remove();
  }

  removeCouponFromReferral(userId, couponId) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${userId}/${couponId}`).remove();
  }

  // redeemCoupon(couponId: string, userId: string) {
  //   return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${userId}/${couponId}/redeemed`).set(true);
  // }

  redeemCoupon(couponId: string, userId: string) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserCoupons/${userId}/${couponId}`).update({
      redeemed: true,
      redeem_at: firebase.database.ServerValue.TIMESTAMP
    });
  }

}
// end file



// WEBPACK FOOTER //
// ./src/providers/coupon.ts